/**
 * @docs docs/features/website-navigation-shell
 */

/*----------------------------------
- MEGA MENU SECTION
----------------------------------*/

import type { ComponentChildren } from 'preact';

/*----------------------------------
- TYPES
----------------------------------*/

type MegaMenuSectionProps = {
    /** The column title, sentence case: ink at 16px heavy (`.mm-lab`, web-recheck-04). */
    title: ComponentChildren;
    children: ComponentChildren;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/**
 * One column of a desktop panel (`.mm-sec`): its title, then its rows. Padded 28px on both sides with a hairline before
 * every column but the first (`marketing.css`). The title is plain text, not a heading: a menu label is not part of the
 * page outline, so the shell renders no heading element.
 */
export default function MegaMenuSection({ title, children }: MegaMenuSectionProps) {
    return (
        <section class="mm-sec">
            <div class="mm-lab">{title}</div>
            {children}
        </section>
    );
}
